import { array, date, object, string } from "yup";

export const schema = (t) => {
  return object({
    datePickerRange: array()
      .required(t("validation:required-field"))
      .min(2, t("validation:required-field")),
  });
};
